/**
 * DemoSwitcher — Floating view switcher for demo school admins.
 * All links use backend-generated magic links so auth works across domains.
 */
import { useState, useEffect } from "react";
import { useAuth } from "../lib/AuthContext";
import { apiGet } from "../lib/api";

const DEMO_SCHOOL_ID = "64260d45-7131-455e-b720-e17e543289a1";
const CURRENT = "Careers";

export default function DemoSwitcher() {
  const { profile, session } = useAuth();
  const [links, setLinks] = useState(null);
  const [loading, setLoading] = useState(false);

  // Only show for admin users on the demo school
  const visible =
    profile &&
    profile.role === "admin" &&
    (profile.school_id === DEMO_SCHOOL_ID || profile.school_id === null);

  // Fetch all demo links once on mount
  useEffect(() => {
    if (!visible || !session?.access_token) return;
    apiGet("/demo/links", session.access_token)
      .then(setLinks)
      .catch((err) => console.error("Failed to fetch demo links:", err));
  }, [visible, session?.access_token]);

  if (!visible) return null;

  const views = [
    { label: "Careers", icon: "🎓", url: null },
    { label: "Recruiter", icon: "💼", url: links?.recruiter_url },
    { label: "Student", icon: "👤", url: links?.student_url },
  ];

  const handleClick = (e, view) => {
    if (view.label === CURRENT) {
      e.preventDefault();
      return;
    }
    if (!view.url) {
      e.preventDefault();
      return;
    }
    // Let the <a> navigate naturally
  };

  return (
    <div style={{
      position: "fixed",
      bottom: 20,
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 10000,
      display: "flex",
      gap: 2,
      backgroundColor: "#1A1917",
      borderRadius: 12,
      padding: 4,
      boxShadow: "0 4px 24px rgba(0,0,0,0.25)",
      fontFamily: "'DM Sans', sans-serif",
    }}>
      {views.map((v) => {
        const isActive = v.label === CURRENT;
        return (
          <a
            key={v.label}
            href={isActive ? "#" : (v.url || "#")}
            onClick={(e) => handleClick(e, v)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "8px 16px",
              borderRadius: 10,
              backgroundColor: isActive ? "#2B5CE6" : "transparent",
              color: isActive ? "#fff" : (v.url ? "#9C9889" : "#555"),
              fontSize: 13,
              fontWeight: 600,
              textDecoration: "none",
              transition: "all 0.15s",
              whiteSpace: "nowrap",
              cursor: isActive ? "default" : (v.url ? "pointer" : "wait"),
            }}
          >
            <span style={{ fontSize: 14 }}>{v.icon}</span>
            {v.label}
          </a>
        );
      })}
      <div style={{
        position: "absolute",
        top: -24,
        left: "50%",
        transform: "translateX(-50%)",
        fontSize: 10,
        color: "#6B6860",
        fontWeight: 600,
        letterSpacing: "0.05em",
        textTransform: "uppercase",
        whiteSpace: "nowrap",
      }}>
        Demo Mode
      </div>
    </div>
  );
}
